import type { ChartValidationRequest, ChartValidationResult } from '../models/chartValidation.types'
import { parseChartValidationResult } from '../models/chartValidation.wire'

import { appHttp, decodeDto, unwrap } from '@/shared/http'

/** Optional server validation for saved/dashboard candidates; catalog constraints remain local UI input. */
export class ChartValidationApi {
  constructor(private readonly app: Pick<typeof appHttp, 'post'> = appHttp) {}

  async validate(
    request: ChartValidationRequest,
    signal?: AbortSignal,
  ): Promise<ChartValidationResult> {
    const config = {
      ...(signal ? { signal } : {}),
      suppressGlobalErrorHandler: true,
      meta: { suppressGlobalErrorHandler: true },
      // 422 is a valid chart-contract result (`valid:false`), not a transport failure.
      validateStatus: (status: number) => status === 200 || status === 422,
    }
    const body = unwrap(
      await this.app.post<unknown>('/custom-dashboard/chart-types/validate/', request, config),
    )
    return decodeDto(body, parseChartValidationResult)
  }
}

export const chartValidationApi = new ChartValidationApi()
